module.exports = __webpack_public_path__ + "static/media/Appendicular.cd78852d.ogg";